"use client";
import "./chunk-N3ETBM74.js";
import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalAuthSettings } from "./msal";
import { consumePostLoginTarget } from "./postLoginTarget";
import { updateSession } from "./utils";
const msalInstance = new PublicClientApplication(msalAuthSettings.config);
const redirectPromise = typeof window === "undefined" ? Promise.resolve(null) : msalInstance.initialize().then(() => msalInstance.handleRedirectPromise({ navigateToLoginRequestUrl: false })).catch((error) => {
  console.error("MSAL redirect handling failed:", error);
  return null;
});
const AuthProvider = ({ children }) => {
  useEffect(() => {
    ;
    (async () => {
      const tokenResponse = await redirectPromise;
      if (tokenResponse == null ? void 0 : tokenResponse.accessToken) {
        msalInstance.setActiveAccount(tokenResponse.account);
        await updateSession(tokenResponse.accessToken);
        const target = consumePostLoginTarget();
        window.location.replace(target != null ? target : "/");
        return;
      }
      if (!tokenResponse && window.location.pathname.includes("/redirect")) {
        if (window.history.length > 1) window.history.back();
        else window.location.href = "/";
      }
    })();
  }, []);
  return /* @__PURE__ */ jsx(MsalProvider, { instance: msalInstance, children });
};
export {
  AuthProvider
};
